import type { TranslationFunction } from '@/app/components/translations/Translation';
// eslint-disable-next-line import/no-cycle
import {
  getActivityFacilities,
  getFamilyFacilities,
  getFoodFacilities,
  getGeneralFacilities,
  getWellnessFacilities,
} from './utils';

export enum AnalyticsFacilities {
  Covid19Measures = 'Covid-19_measures',
  SwimmingPool = 'Swimming_pool',
  FreeWifi = 'Free_Wifi',
  SpaWellness = 'Spa/Wellness',
  Children = 'Children',
  Accessibility = 'Accessibility',
  PetFriendly = 'Pet-friendly',
  Entertainment = 'Entertainment',
  AdultsOnly = 'Adults_only',
  Parking = 'Parking',
  Seafront = 'Seafront',
  Kitchen = 'Kitchen',
  EvCharge = 'EV_charge',
  Fitness = 'Fitness_facilities',
  RooftopTerrace = 'Rooftop_terrace',
  ChildrenPlayground = 'Children_playground',
  BabySitting = 'Baby_sitting',
  ChildrenClubs = 'Children_clubs',
  ChildrenMeal = 'Children_meal',
  ChildrenPool = 'Children_pool',
  Hiking = 'Hiking',
  Fishing = 'Fishing',
  Cycling = 'Cycling',
  BoardGames = 'Board_games',
  HorseRiding = 'Horse_riding',
  Golf = 'Golf',
  BicycleRental = 'Bicycle_rental',
  Canoe = 'Canoe',
  Diving = 'Diving',
  WindSurfing = 'Wind_surfing',
  WaterPark = 'Water_park',
  Snorkeling = 'Snorkeling',
  Bowling = 'Bowling',
  Billiards = 'Billiards',
  Scuba = 'Scuba',
  Massage = 'Massage',
  WaterSports = 'Water_sports',
  EveningEntertainment = 'Evening_entertainment',
  TennisCourt = 'Tennis_court',
  ArcadeRoom = 'Arcade_room',
  Kayaking = 'Kayaking',
  EcoTours = 'Eco_tours',
  Yoga = 'Yoga',
  NightClub = 'Night_club',
  Darts = 'Darts',
  IndoorPlayArea = 'Indoor_play_area',
  IndoorPool = 'Indoor_pool',
  RooftopPool = 'Rooftop_pool',
  Hammam = 'Hammam',
  Sauna = 'Sauna',
  SteamRoom = 'Steam_room',
  SaltPool = 'Salt_pool',
  InfinityPool = 'Infinity_pool',
  WaterSlide = 'Water_slide',
  SunTerrace = 'Sun_terrace',
  Picnic = 'Picnic',
  Bar = 'Bar',
  Pool_bar = 'Pool_bar',
  Restaurant = 'Restaurant',
  Bbq = 'Bbq',
  MiniMarket = 'Mini_market',
}

export const getFacilitiesDict = (t: TranslationFunction) => [
  ...getGeneralFacilities(t),
  ...getFamilyFacilities(t),
  ...getActivityFacilities(t),
  ...getWellnessFacilities(t),
  ...getFoodFacilities(t),
];
